import { ICards } from '../cards/types';
import { IApplicationState, TCardId } from '../../../types/types';
import { getCard } from './getCard';
import { getSubcardsMaxDate } from './getSubcardsMaxDate';
import { ICardsDatesDelta } from 'app/types/ICardsDatesDelta';
import { getCardEpicChecklistsDueDate } from './getCardEpicChecklistsDueDate';

export const getCardEpicsForDueDateChange = (
    state: IApplicationState,
    epicId: TCardId,
    cards: ICards = {},
    cardDatesUpdate: ICardsDatesDelta = {}
): ICards => {
    if (!epicId){
        return  cards;
    }
    const epic = getCard(state, epicId);
    if (!epic) return cards;
    const checklistsDueDate = getCardEpicChecklistsDueDate(state, epicId);
    const subcardMaxDate = getSubcardsMaxDate(state, epicId, cards);
    const dueDate = subcardMaxDate > checklistsDueDate ? subcardMaxDate : checklistsDueDate;
    const epicDueDate = cards[epicId] && cards[epicId].dueDate !== undefined ? cards[epicId].dueDate : epic.dueDate;
    if (epicDueDate !== dueDate){
        cards[epicId] = {
            ...cards[epicId],
            dueDate
        };
        if (dueDate && epic.dueDate) {
            cardDatesUpdate[epicId] = {...cardDatesUpdate[epicId], ...{deltaDueDate: dueDate - epic.dueDate}};
        }
        return getCardEpicsForDueDateChange(state, epic.epicId, cards, cardDatesUpdate);
    }
    return cards;
}
